<div *ngIf="rows.length > 0" class="trigger-map-view">
  <div *ngFor="let row of rows" class="trigger-map-row">
    <span class="trigger-name">{{ row.triggerName }}</span>
    <span class="separator"> → </span>
    <span class="asset-name">{{ row.optionValue }}</span>
  </div>
</div>
<span *ngIf="rows.length === 0">—</span>
